import React from "react";

export default function SilenceOverviewPageEn() {
  return (
    <div
      style={{
        maxWidth: 700,
        margin: "48px auto",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0001",
        padding: 36,
        fontFamily: "inherit",
        color: "#222",
      }}
    >
      <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
        Silence monitoring
      </h2>

      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Forget about unexpected on-air “dropouts”. Our service{" "}
        <b>monitors your radio streams (MP3 and AAC+) 24/7</b>{" "}
        and instantly notifies you about silence.
      </p>

      <ul style={{ paddingLeft: 18, margin: "14px 0" }}>
        <li style={{ marginBottom: 8 }}>
          Alerts arrive <b>in Telegram</b> right after an issue is detected.
        </li>
        <li style={{ marginBottom: 8 }}>
          You can add <b>two additional contacts</b>{" "}
          (e.g. engineering or programming team) — already included in the price.
        </li>
        <li style={{ marginBottom: 8 }}>
          A <b>7-day history of volume levels</b> is available for each stream{" "}
          with second-level precision — you always see what happened on air.
        </li>
      </ul>

      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Simple connection, no extra hardware. Your broadcast is under reliable control.
      </p>
    </div>
  );
}
